import { render, staticRenderFns } from "./resumorhprojeto.vue?vue&type=template&id=e09055cc&scoped=true&"
import script from "./resumorhprojeto.vue?vue&type=script&lang=js&"
export * from "./resumorhprojeto.vue?vue&type=script&lang=js&"
import style0 from "./resumorhprojeto.vue?vue&type=style&index=0&id=e09055cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e09055cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VDataTable,VIcon})
